import { axiosInstance as axios } from '../../boot/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // 取得單據狀態清單
    GetStockStatusList({ commit, rootGetters }, request) {
      return axios
        .get('StockCabinet/GetStockStatusList')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得門店清單
    GetStoreList({ commit, rootGetters }, request) {
      return axios
        .get('StockCabinet/GetStoreList')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得目前庫存清單
    GetCabinetNow({ rootGetters }, request) {
      return axios
        .post('StockCabinet/GetCabinetNow', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得入庫管理資料清單
    GetCabinetIn({ rootGetters }, request) {
      return axios
        .post('StockCabinet/GetCabinetIn', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 新增入庫資料
    AddCabinetIn({ rootGetters }, request) {
      return axios
        .post('StockCabinet/AddCabinetIn', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得入庫管理資料明細
    GetCabinetInDetail({ commit, rootGetters }, request) {
      return axios
        .get('StockCabinet/GetCabinetInDetail', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 編輯入庫資料
    UpdateCabinetIn({ rootGetters }, request) {
      return axios
        .put('StockCabinet/UpdateCabinetIn', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 確認入庫
    ConfirmCabinetIn({ rootGetters }, request) {
      return axios
        .put('StockCabinet/ConfirmCabinetIn', null, { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    DeleteCabinetIn({ commit, rootGetters }, request) {
      return axios
        .delete('StockCabinet/DeleteCabinetIn', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得出庫管理資料清單
    GetCabinetOut({ rootGetters }, request) {
      return axios
        .post('StockCabinet/GetCabinetOut', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 新增出庫資料
    AddCabinetOut({ rootGetters }, request) {
      return axios
        .post('StockCabinet/AddCabinetOut', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得出庫管理資料明細
    GetCabinetOutDetail({ commit, rootGetters }, request) {
      return axios
        .get('StockCabinet/GetCabinetOutDetail', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 編輯出庫資料
    UpdateCabinetOut({ rootGetters }, request) {
      return axios
        .put('StockCabinet/UpdateCabinetOut', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 確認出庫
    ConfirmCabinetOut({ rootGetters }, request) {
      return axios
        .put('StockCabinet/ConfirmCabinetOut', null, { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    DeleteCabinetOut({ commit, rootGetters }, request) {
      return axios
        .delete('StockCabinet/DeleteCabinetOut', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    // 取得調撥管理資料清單
    GetCabinetTr({ rootGetters }, request) {
      return axios
        .post('StockCabinet/GetCabinetTr', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 新增調撥資料
    AddCabinetTr({ rootGetters }, request) {
      return axios
        .post('StockCabinet/AddCabinetTr', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得調撥管理資料明細
    GetCabinetTrDetail({ commit, rootGetters }, request) {
      return axios
        .get('StockCabinet/GetCabinetTrDetail', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 編輯調撥資料
    UpdateCabinetTr({ rootGetters }, request) {
      return axios
        .put('StockCabinet/UpdateCabinetTr', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 確認調撥
    ConfirmCabinetTr({ rootGetters }, request) {
      return axios
        .put('StockCabinet/ConfirmCabinetTr', null, { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    DeleteCabinetTr({ commit, rootGetters }, request) {
      return axios
        .delete('StockCabinet/DeleteCabinetTr', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    // 取得庫存未結算清單
    GetStockSettleYet({ rootGetters }, request) {
      return axios
        .post('StockCabinet/GetStockSettleYet', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddStockSettle({ rootGetters }, request) {
      return axios
        .post('StockCabinet/AddStockSettle', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateCabinetNow({ rootGetters }, request) {
      return axios
        .put('StockCabinet/UpdateCabinetNow')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得庫存結算歷史
    GetStockSettle({ rootGetters }, request) {
      return axios
        .post('StockCabinet/GetStockSettle', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetStockSettleByID({ rootGetters }, request) {
      return axios
        .post('StockCabinet/GetStockSettleByID', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    DelStockSettle({ commit, rootGetters }, request) {
      return axios
        .delete('StockCabinet/DelStockSettle', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 還原最後一期結算
    RecoveryLastSettle({ rootGetters }, request) {
      return axios
        .put('StockCabinet/RecoveryLastSettle')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 新增门店补货信息
    SetStoreReplenishment({ rootGetters }, request) {
      return axios
        .post('StockCabinet/SetStoreReplenishment', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetStoreReplenishmentDetail({ rootGetters }, request) {
      return axios
        .post('StockCabinet/GetStoreReplenishmentDetail', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    StoreReplenishmentOperate({ rootGetters }, request) {
      return axios
        .post('StockCabinet/StoreReplenishmentOperate', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetStoreOrderApplyAss({ commit, rootGetters }, request) {
      return axios
        .get('StockCabinet/GetStoreOrderApplyAss', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    ReplenishmentAddApplyAssemblyOrder({ rootGetters }, request) {
      return axios
        .post('StockCabinet/ReplenishmentAddApplyAssemblyOrder', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    ExportCabinetNowExcel({ commit, rootGetters }, request) {
      return axios
        .post(
          'StockCabinet/ExportCabinetNowExcel',
          {
            ...request
          },
          { responseType: 'blob' }
        )
        .then((response) => {
          return Promise.resolve(response.data)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    }
  }
}
